import { collection, getAggregateFromServer, getDocs, sum } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { db } from '../../../../../firebase';
import { useAuth } from '../../../../../context/AuthContext';
import { Badge } from 'react-bootstrap';

const TotalOutstanding = ({ bookingID }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [totalAmount, setTotalAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);

  async function getSumOfPaidAmount() {
    const ref = collection(db, 'Businesses', bid, "Bookings", bookingID, "Invoices");
    const querySnapshot = await getDocs(ref);

    let totalReceived = { instalmentAmount: 0, interestAmount: 0 };
    querySnapshot.forEach(doc => {
      const r = doc.data().amountReceived || {};
      totalReceived.instalmentAmount += r.instalmentAmount || 0;
      totalReceived.interestAmount += r.interestAmount || 0;
    });
    totalReceived = parseFloat(totalReceived.instalmentAmount + totalReceived.interestAmount);
    setPaidAmount(totalReceived);
  }

  async function getSumOfAmount() {
    const ref = collection(db, 'Businesses', bid, "Bookings", bookingID, "Invoices");
    const snapshot = await getAggregateFromServer(ref, {
      basicAmount: sum("basicAmount"),
      additionalCharges: sum("additionalCharges"),
      overdueCharges: sum("overdueCharges")
    });

    getSumOfPaidAmount();
    const tempTotalAmount = parseFloat(snapshot.data().basicAmount + snapshot.data().additionalCharges + snapshot.data().overdueCharges);
    setTotalAmount(tempTotalAmount);
  }

  useEffect(() => {
    getSumOfAmount();
  }, [])

  const calculatedAmount = parseFloat(totalAmount) - parseFloat(paidAmount);

  if (calculatedAmount === 0) {
    return (
      <Badge
        bg='success px-3 py-1 fw-normal'
        className='mb-0 fw-600'
      >
        Paid
      </Badge>
    );
  } else {
    return calculatedAmount ? `₹ ${parseFloat(calculatedAmount.toFixed(2)).toLocaleString("en-IN")}` : 0;
  }
}

export default TotalOutstanding;
